/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLanConnect: {
  name: 'lan-connect';
  data: string;
} = {
  name: 'lan-connect',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm8 0H5v4h6V5Zm0 10a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-4Zm8 0h-6v4h6v-4ZM5 14a1 1 0 1 0-2 0v3a2 2 0 0 0 2 2h3a1 1 0 1 0 0-2H5v-3Z" fill="currentColor"/></svg>`,
};
